<template>
  <div
    class="lms_select_card"
    :class="{
      is_selected: selected,
      is_disabled: disabled,
    }"
    @click="handleSelect"
  >
    <div class="card_content">
      <slot>{{ label }}</slot>
    </div>

    <div class="check_icon_wrap" v-if="selected">
      <svg
        width="14"
        height="11"
        viewBox="0 0 14 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 5.5L4.66667 9.5L13 1"
          stroke="white"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
const model = defineModel<string | number | null>({ required: true });

const props = defineProps({
  label: { type: String, default: "" },
  value: { type: [String, Number], required: true },
  disabled: { type: Boolean, default: false },
  selected: { type: Boolean, default: false }, // 초기 선택 여부 (v-model과 별개로 최초 렌더링 시 선택 상태 제어용)
});

const emit = defineEmits(["change"]);

const handleSelect = () => {
  if (!props.disabled) {
    model.value = props.value;
    emit("change", props.value);
  }
};
</script>

<style scoped>
.lms_select_card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  padding: 0 16px;

  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;

  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.02);
}

.card_content {
  font-family: "Pretendard", sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #000000b2;
  user-select: none;
}

.lms_select_card.is_selected {
  border: 1.5px solid #5c74f6;
  box-shadow: 0px 4px 12px rgba(92, 116, 246, 0.15);
}

.check_icon_wrap {
  width: 20px;
  height: 20px;
  background-color: #5c74f6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lms_select_card:hover:not(.is_disabled) {
  border-color: #5c74f6;
  background-color: #f9faff;
}

.lms_select_card.is_disabled {
  border-color: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.6;
}

.lms_select_card.is_disabled .card_content {
  color: #00000059;
}
</style>
